import { api } from "../api/config";

// Leituras de items via extensão native-dashboards-data (dashboards data_scope=global).
// Mesmo shape de resposta do getItems ({ items, metadata }) para ser drop-in nos call sites;
// os fields enviados são informativos — o endpoint impõe SEMPRE os da whitelist.
type ExtensionItemsOptions = {
    filter?: any;
    page?: number;
    pageSize?: number;
    sort?: string;
};

export const getExtensionItems = async (
    dashboardKey: string,
    route: "drill" | "widget-items",
    entity: string,
    fieldsQuery: string,
    options?: ExtensionItemsOptions
): Promise<{ items: any; metadata: { total_count?: number; filter_count?: number } }> => {
    const queryParams = `limit=${options?.pageSize || 300}&page=${options?.page ? options.page + 1 : 1}&meta=*`;

    const response = await api({
        method: "GET",
        params: {
            fields: fieldsQuery,
            filter: options?.filter ? JSON.stringify(options.filter) : undefined,
            sort: options?.sort,
        },
        url: `/native-dashboards-data/${dashboardKey}/${route}/${entity}?${queryParams}`,
    });

    const items = response.data.data;
    const metadata = response.data.meta;
    return { items, metadata };
};
